"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionalUserIdAmbientValue = exports.UserIdAmbientValue = void 0;
const AmbientValue_1 = require("./AmbientValue");
class UserIdAmbientValue extends AmbientValue_1.AmbientValue {
    constructor() {
        super(...arguments);
        this.name = "userId";
    }
}
exports.UserIdAmbientValue = UserIdAmbientValue;
class OptionalUserIdAmbientValue extends AmbientValue_1.AmbientValue {
    constructor() {
        super(...arguments);
        this.name = "userId?";
    }
}
exports.OptionalUserIdAmbientValue = OptionalUserIdAmbientValue;
//# sourceMappingURL=UserIdAmbientValue.js.map